export default __webpack_public_path__ + "images/0x4ed4e862860bed51a9570b96d89af5e1b0efefed.png";